import { logError } from '../../../utils/logger'
import { formatAuthLibraryError } from '../../../utils/msalAuthError'

export const getGlimpseApiTokenMutation = async (auth0Client, silent, popup) => {
  let glimpseApiToken

  try {
    if (silent) glimpseApiToken = await auth0Client.getAccessTokenSilently()
    else glimpseApiToken = await auth0Client.getAccessTokenWithPopup()
  } catch (error) {
    logError(error, 'entities/auth/service > getGlimpseApiTokenMutation (initial)')
    if (popup && typeof popup.close === 'function') {
      try {
        popup.close()
      } catch (_) {
        /* ignore */
      }
    }
    const isPopupClosed =
      error.message === 'Popup closed' ||
      error.message === 'Popup window closed' ||
      error.errorCode === 'user_cancelled' ||
      (error.message && String(error.message).includes('user_cancelled'))

    if (isPopupClosed) {
      console.error('Auth popup was closed by user:', error.message || error.errorCode)
      throw error
    }

    try {
      glimpseApiToken = await auth0Client.getAccessTokenWithPopup()
    } catch (retryError) {
      logError(retryError, 'entities/auth/service > getGlimpseApiTokenMutation (retry popup)')
      throw new Error(formatAuthLibraryError(retryError))
    }
  }

  if (typeof glimpseApiToken === 'undefined') {
    return null
  }

  return glimpseApiToken
}
